import React from "react";
import { PropTypes } from "prop-types";
import { Row, Col } from "antd";
import { connect } from "react-redux";
import AccordionOpenStateContent from "./AccordionOpenStateContent/AccordionOpenStateContent";
import MultipleCharitiesAccordion from "./MultipleCharitiesAccordion";
import {CustomRow} from '../styles';
import { basicSuccessorsInfo } from '../../DefaultPropTypes';

export const AccordionOpenState = props => {
  return (
    <div>
      {props.contentKey != 4 ? (
        <div>
          <Row>
            <Col lg={{ span: 10 }} md={{ span: 10 }}>
              {Array.prototype.map.call(props.successors, (val, index) => {
                if ((index + 1) % 2 != 0) {
                  return (
                    <AccordionOpenStateContent
                      id={"accordionOpenStateContent"+index}
                      successor={val}
                      index={index}
                      contentKey={props.contentKey}
                    />
                  );
                }
              })}
            </Col>
            <Col lg={{ span: 12, offset: 1 }} md={{ span: 12, offset: 1 }}>
              {Array.prototype.map.call(props.successors, (val, index) => {
                if ((index + 1) % 2 === 0) {
                  return (
                    <AccordionOpenStateContent
                      id={"accordionOpenStateContent"+index}
                      successor={val}
                      index={index}
                      contentKey={props.contentKey}
                    />
                  );
                }
              })}
            </Col>
          </Row>
        </div>
      ) : (
        <div>
            <CustomRow>
              {props.charitySuccessors != "" && (
                <>
                  {props.charitySuccessors.map((val, index) => {
                    return (
                    <Col key={index+1} lg={{ span: 12 }} md={{ span: 12 }}>
                        <MultipleCharitiesAccordion
                          id={"accordionMultipleCharities"+index}
                          successor={val}
                          index={index}
                          contentKey={props.contentKey}
                        />
                      </Col>
                          );
                      })}
                    </>
                  )}
                </CustomRow>
                <CustomRow>
                    {props.successors != "" && (
                      <>
                        {props.successors.map((val, index) => {
                          if ((index + 1) % 2 === 0) {
                            return (
                              <Col key={index+1} lg={{ span: 12, offset: 1 }} md={{ span: 12, offset: 1 }}>
                                <MultipleCharitiesAccordion
                                  id={"accordionMultipleCharities"+index}
                                  successor={val}
                                  index={index}
                                  contentKey={props.contentKey}
                                  />
                              </Col>
                            );
                          }
                        })}
                      </>
                    )}
                </CustomRow>
            
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  percentage: state.getIn([
    "npaFormReducer",
    "tempJSON",
    "tempJSON",
    "tempJSON",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "percentage"
  ]),
  successors: state.getIn([
    "npaFormReducer",
    "tempJSON",
    "tempJSON",
    "tempJSON",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "successorAdvisor"
  ]),
  charitySuccessors: state.getIn([
    "npaFormReducer",
    "tempJSON",
    "tempJSON",
    "tempJSON",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "successionPlanGranteeOrg"
  ])
});

AccordionOpenState.propTypes = {
  charitySuccessors: PropTypes.string,
  contentKey: PropTypes.number,
  dispatch: PropTypes.func,
  percentage: PropTypes.string,
  successors: PropTypes.arrayOf(basicSuccessorsInfo)
}

export default connect(mapStateToProps)(AccordionOpenState);
